import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { HttpClient } from '@angular/common/http';

interface ReleaseNote {
    version: string;
    date: string;
    description: string;
}

@Component({
    selector: 'app-release-notes-dialog',
    standalone: true,
    imports: [CommonModule, MatDialogModule, MatIconModule],
    templateUrl: './release-notes-dialog.component.html',
    styleUrls: ['./release-notes-dialog.component.scss']
})
export class ReleaseNotesDialogComponent implements OnInit {

    releaseNote: ReleaseNote | null = null;
    loading: boolean = true;

    constructor(
        public dialogRef: MatDialogRef<ReleaseNotesDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { version: string },
        private http: HttpClient
    ) {}

    ngOnInit(): void {
        // Load release notes from JSON file
        this.http.get<ReleaseNote>('assets/release-notes.json').subscribe({
            next: (data) => {
                this.releaseNote = data;
                this.loading = false;
            },
            error: (err) => {
                console.error('Failed to load release notes:', err);
                this.loading = false;
            }
        });
    }

    getFormattedDescription(description: string): string {
        return description.replace(/\n/g, '<br>');
    }

    close(): void {
        this.dialogRef.close();
    }
}